import { Component, ViewChild, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-comune-rpi-autocomplete',
  templateUrl: './comune-rpi-autocomplete.component.html',
  styleUrls: ['./comune-rpi-autocomplete.component.scss'],
})
export class ComuneRpiAutocompleteComponent implements OnChanges {
  @Input() comuniList: any;
  @Input() comuneLabel: string;
  @Output() comuneSelected = new EventEmitter<any>();
  @ViewChild('searchTextField', { static: false }) searchTextField: any;
  comuneControl = new FormControl();
  comuniOptions: any;
  convertedComuniList: any;

  ngOnChanges(changes) {
    if (changes && changes.comuniList) {
      this._initAutoComplete();
    }
  }

  emitComune(e) {
    this.comuneSelected.emit(e);
  }

  private _filter = (value: string | any, list) => {
    const isEntireObject = value instanceof Object;
    return list.filter((option: any) =>
      option[1].toLowerCase().includes(
        !isEntireObject ? value.toLowerCase() : value[1].toLowerCase(),
      ),
    );
  };

  private _initAutoComplete() {
    if (this.comuniList) {
      this.convertedComuniList = Object.entries(this.comuniList)
      this.comuniOptions = this.comuneControl.valueChanges.pipe(
        startWith(''),
        map((value) => this._filter(value as string, this.convertedComuniList)),
      );
    }
  }

}
